import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountSessionExpiredService } from '@app/core/libraries';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.css'],
    imports: [RouterModule, HeaderComponent, FooterComponent, SidebarComponent],
    providers: [AccountSessionExpiredService],
})
export class ShellComponent {
    readonly accountSessionExpiredService = inject(AccountSessionExpiredService);
}
